import React from 'react';
import { Helmet } from 'react-helmet';
import blogPosts from '../data/dbPosts';


const PageBlog = () => {
    const [visiblePosts, setVisiblePosts] = React.useState([]);
    const [postsToShow, setPostsToShow] = React.useState(6);

    React.useEffect(() => {
        const today = new Date();
        const filteredPosts = blogPosts
            .filter(post => (new Date(post.date) < today) && post.content)
            .sort((a, b) => new Date(b.date) - new Date(a.date));
        setVisiblePosts(filteredPosts.slice(0, postsToShow));
    }, [postsToShow]);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        const windowHeight = window.innerHeight;
        const fullHeight = document.documentElement.offsetHeight;

        if (scrollTop + windowHeight >= fullHeight - 100) {
            setPostsToShow(prev => Math.min(prev + 3, blogPosts.length));
        }
    };

    React.useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return <>
        <Helmet>
            <title>Blog | Sparkling Email</title>
            <meta name="description" content="Blog | Sparkling Email" />
            <meta name="keywords" content="Blog, Articles, News, Updates" />
            <meta name="author" content="Sparkling Email" />
            <meta name="robots" content="index, follow" />
            <meta name="googlebot" content="index, follow" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <meta property="og:title" content="Blog | Sparkling Email" />
            <meta property="og:description" content="Blog | Sparkling Email" />
            <meta property="og:image" content="https://sparklingemail.com/logo.png" />
            <meta property="og:url" content="https://sparklingemail.com/blog" />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Sparkling Email" />
            <meta property="og:locale" content="en_US" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Blog | Sparkling Email" />
            <meta name="twitter:description" content="Blog | Sparkling Email" />
            <meta name="twitter:image" content="https://sparklingemail.com/logo.png" />
            <meta name="twitter:site" content="@sparklingemail" />
            <meta name="twitter:creator" content="@sparklingemail" />
        </Helmet>
        <section className="container py-5 text-dark">
            <div className="row justify-content-center mb-5 text-center">
                <div className="col-12 col-md-8">
                    <h1 className="display-4">Blog</h1>
                    <p className="lead">
                        Discover expert insights, real-world use cases, and smart tips on bilingual business communication—powered by Sparkling Email.
                    </p>
                </div>
            </div>
            <div className="row justify-content-center mb-3">
                {visiblePosts.map((post) => (
                    <a href={`/blog/${post.slug}`} key={post.date} className="col-12 col-md-6 col-lg-4 mb-4 text-decoration-none text-dark">
                        <div className="card h-100 shadow-sm border-0">
                            <img src={post.image || ""} className="card-img-top" alt={post.title} />
                            <div className="card-body">
                                <h5 className="card-title">{post.title}</h5>
                                <p className="card-text">{post.excerpt}</p>
                            </div>
                            <div className="card-footer bg-white border-0 d-flex justify-content-between align-items-center">
                                <small className="fs-8 text-muted">
                                    {post.tags && post.tags.map(tag => `#${tag}`).join(' ')}
                                </small>
                                <small className="fs-8 text-muted">{post.date}</small>
                            </div>
                        </div>
                    </a>
                ))}
            </div>
        </section>
    </>
}

export default PageBlog;